<template>
  <div>
    <modal :show.sync="editModal" header-classes="bg-primary p-3">
      <h6 slot="header" class="modal-title text-white font-semibold pt-1">
        ADD TAX
      </h6>
      <AddPageDetail />
      <template slot="footer">
        <base-button type="primary">SUBMIT</base-button>
        <base-button type="secondary" class="ml-auto" @click="editModal = false"
          >CLOSE</base-button
        >
      </template>
    </modal>
    <b-card class="bg-white">
      <div class="flex  justify-between  items-center">
        <div>
          <h2 class="text-2xl font-semibold">
            Taxes
          </h2>

          <!-- <small class=" text-muted "
            >Lorem ipsum dolor sit amet, consectetur adipiscing elit,
          </small> -->
        </div>
        <!-- <div>
          <base-button outline type="success" class="flex">
            <feather-icon icon="PlusIcon" class="mr-1"></feather-icon>Manage
            Accounts
          </base-button>
        </div> -->
      </div>

      <div class="w-full mt-12">
        <div class="">
          <b-tabs class="nav-pills-w" pills>
            <b-tab active>
              <template v-slot:title>
                Tax Details
              </template>
              <b-card class="mt-8 px-12 border-none" no-body>
                <div class="">
                  <div class="flex items-center">
                    <p class="font-medium ">
                      Is your business resgister for GST
                    </p>
                    <b-form>
                      <b-form-radio
                        v-model="selected"
                        name="some-radios"
                        class="radio-align custom-control-inline mr-0"
                        value="A"
                        >Yes</b-form-radio
                      >
                      <b-form-radio
                        v-model="selected"
                        name="some-radios"
                        class="radio-align custom-control-inline mr-0"
                        value="B"
                        >No</b-form-radio
                      >
                    </b-form>
                  </div>
                  <div class="row items-end mt-2">
                    <div class="selectcard-hover items-center mt-3 col-sm-6 ">
                      <p class="font-semibold text-sm">
                        GST<span class="text-danger pl-1">*</span>
                      </p>
                      <small class="text-muted text-xs"
                        >Maximum 15 digits</small
                      >
                      <b-input placeholder="Enter Tags..." class="mt-2" />
                    </div>
                    <div class=" col-sm-6">
                      <p class="font-semibold text-sm mb-2">States</p>
                      <base-input class="div-mb-0">
                        <select class="form-control ">
                          <option disabled="true">Select</option>
                          <option>Maharashtra</option>
                          <option>Uttar Pradesh</option>
                        </select>
                      </base-input>
                    </div>
                  </div>

                  <base-button
                    type="primary"
                    class=" mt-8 float-right font-semibold"
                    >Save</base-button
                  >
                </div>
              </b-card>
            </b-tab>

            <b-tab>
              <template v-slot:title>
                Total Tax
              </template>
              <b-card class=" mt-8 px-12  border-none" no-body>
                <div class="">
                  <div class="flex justify-between  items-center">
                    <div>
                      <h2 class="text-lg font-semibold">
                        Tax Rates
                      </h2>
                    </div>
                    <div>
                      <base-button
                        outline
                        type="success"
                        @click="editModal = true"
                        class="flex btn-pd6-20"
                      >
                        <feather-icon
                          icon="PlusIcon"
                          class="mr-1"
                        ></feather-icon
                        >Add Tax
                      </base-button>
                    </div>
                  </div>
                  <div class="row items-end mt-2">
                    <TaxRateTable />
                  </div>

                  <base-button
                    type="primary"
                    class=" mt-8 float-right font-semibold"
                    >Save</base-button
                  >
                </div>
              </b-card>
            </b-tab>

            <b-tab>
              <template v-slot:title>
                Seperate Tax
              </template>
              <div class="row  px-12 mt-8 items-end mt-2">
                <div class=" col-sm-6">
                  <p class="font-semibold text-sm mb-2">Intra States</p>
                  <base-input class="div-mb-0">
                    <select class="form-control ">
                      <option disabled="true" selected> Select</option>
                      <option>Maharashtra</option>
                      <option>Uttar Pradesh</option>
                    </select>
                  </base-input>
                </div>
                <div class=" col-sm-6">
                  <p class="font-semibold text-sm mb-2">Inter States</p>
                  <base-input class="div-mb-0">
                    <select class="form-control ">
                      <option disabled="true" selected>Select</option>
                      <option>Maharashtra</option>
                      <option>Uttar Pradesh</option>
                    </select>
                  </base-input>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </b-card>
  </div>
</template>
<script>
import "../../scss/Index.scss";
import TaxRateTable from "./components/TaxRateTable.vue";
import AddPageDetail from "./components/AddPageDetail";
export default {
  data() {
    return { editModal: false, selected: false };
  },
  components: {
    TaxRateTable,
    AddPageDetail
  }
};
</script>
<style>
.nav-pills-w > div > .nav-pills li {
  width: 30%;
  text-align: center;
}
.nav-pills-w > div > .nav-pills {
  justify-content: center;
}
.radio-align label::before {
  left: -2rem !important;
}
.div-mb-0 .form-group {
  margin-bottom: 0rem !important;
}
</style>
